// src/config/version.ts
import packageJson from "../../package.json";

const FALLBACK_VERSION = typeof packageJson.version === "string" ? packageJson.version : "0.0.0";

const rawVersion = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? FALLBACK_VERSION;

function normalizeVersion(version: string): string {
  if (!version) {
    return "v0.0.0";
  }

  return version.toLowerCase().startsWith("v") ? version : `v${version}`;
}

export function getAppVersionLabel(): string {
  return normalizeVersion(rawVersion);
}

